// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import state from './state'

import createPersistedState from "vuex-persistedstate"
//import * as Cookies from 'js-cookie'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state,
  plugins: [
    createPersistedState({paths:['projectForDetailsPage'],storage: window.localStorage})
  ],
  
})

export default store